import { FC } from "react";
import { getStaticUrl } from "../../utils";

interface TeamCardProps {
    title: string;
    city?: string;
    logoUrl?: string;
}

export const TeamCard: FC<TeamCardProps> = ({
    title,
    city,
    logoUrl
}) => {
    return (
        <div className="flex flex-col justify-start items-center gap-2 min-w-28">
            <img src={getStaticUrl(logoUrl)} alt={title} className="w-24 sm:w-52 aspect-square object-contain" />
            <div className="text-lg sm:text-4xl uppercase italic font-semibold text-center">
                {title}
            </div>
            {city && <div>
                {city}
            </div>}
        </div>
    )
}